module.exports = __webpack_public_path__ + "static/media/olake-home-mobile.e65000c1.svg";